// Angular imports
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Guard imports
import { AuthGuard } from '../_guards/auth.guard';
import { AccessGuard } from '../_guards/access.guard';

// Constant imports
import { CiraHelpKeyConstants } from '../_constants/cira-help-key-constants';

// Component imports
import { UserPortfolioMainComponent } from './user-portfolio-main/user-portfolio-main.component';
import { UserCommunitiesComponent } from './user-communities/user-communities.component';
import { UserCommunitiesMapComponent } from './user-communities-map/user-communities-map.component';
import { UserCloudDriveComponent } from './user-cloud-drive/user-cloud-drive.component';

const routes: Routes = [
    {
        path: '',
        component: UserPortfolioMainComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'my-communities',
                pathMatch: 'full',
                component: UserCommunitiesComponent,
                canActivate: [AuthGuard, AccessGuard],
                data: { pageTitle: 'My Communities', helpKey: CiraHelpKeyConstants.portfolioCommunities }
            },
            {
                path: 'my-communities-map',
                pathMatch: 'full',
                component: UserCommunitiesMapComponent,
                canActivate: [AuthGuard, AccessGuard],
                data: { pageTitle: 'Map of My Communities', helpKey: CiraHelpKeyConstants.portfolioCommunitiesMap }
            }
        ]
    },
    {
        path: 'cloud-drive',
        component: UserCloudDriveComponent,
        data: { newWindow: true, resizable: false },
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'vendor-management',
        loadChildren: () =>
            import('../vendor-management/vendor-management-module/vendor-management.module').then(
                (m) => m.VendorManagementModule
            ),
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'my-tests',
        loadChildren: () => import('../my-tests-module/my-tests.module').then((m) => m.MyTestsModule),
        data: { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true },
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'testing-config',
        loadChildren: () => import('../testing-config-module/testing-config.module').then((m) => m.TestingConfigModule),
        data: { pageTitle: 'Testing Configuration', helpKey: CiraHelpKeyConstants.testingConfiguration },
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'my-text',
        loadChildren: () => import('../my-text-module/my-text.module').then((m) => m.MyTextModule),
        data: { anonymousAccess: false, newWindow: true, resizable: false, outletOnly: true },
        canActivate: [AuthGuard]
    },
    {
        path: 'achievements',
        loadChildren: () => import('../achievements-module/achievements.module').then((m) => m.AchievementsModule),
        data: { pageTitle: 'Achievements', helpKey: CiraHelpKeyConstants.achievements },
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'test-plan-configuration',
        loadChildren: () =>
            import('../test-plan-configuration/test-plan-configuration.module').then(
                (m) => m.TestPlanConfigurationModule
            ),
        data: {
            pageTitle: 'Test Plan Configuration',
            helpKey: CiraHelpKeyConstants.testPlanConfiguration
        },
        canActivate: [AuthGuard, AccessGuard]
    },
    {
        path: 'gcb',
        loadChildren: () =>
            import('../cirabooks/general-cirabooks-module/general-cirabooks.module').then(
                (m) => m.GeneralCirabooksModule
            ),
        canActivate: [AuthGuard]
    },
    {
        // Route for Account Management module
        path: 'account-management',
        loadChildren: () =>
            import('../account-management-module/account-management.module').then((m) => m.AccountManagementModule),
        canActivate: [AuthGuard, AccessGuard]
    },
    { path: '**', pathMatch: 'full', redirectTo: '/home' }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserPortfolioRoutingModule {}
